import React from "react";
import { withRouter } from "react-router-dom";
import { graphql, compose } from "react-apollo";
import gql from "graphql-tag";
import Button from "./utilities/Button";
import ErrorBoundary from "./ErrorBoundary";
import ContentLoader from "react-content-loader";

class LoginUser extends React.Component {
  state = {
    email: "",
    password: "",
    disabled: false,
    error: false
  };

  handleSubmit = e => {
    e.preventDefault();
    this.authenticateUser();
  };

  authenticateUser = async () => {
    const { email, password } = this.state;
    this.setState({
      disabled: true
    });
    await this.props
      .authenticateUserMutation({
        variables: { email, password }
      })
      .then(resp => {
        localStorage.setItem(
          "graphcoolToken",
          resp.data.authenticateUser.token
        );
        //this.props.history.replace("/"); won't work because we are already on "/"
        window.location.reload();
      })
      .catch(error => {
        this.setState({
          error: true,
          disabled: false
        });
      });
  };

  render() {
    if (this.props.loggedInUserQuery.loading) {
      return (
        <section className="hero is-fullheight is-vcentered">
          <div className="hero-body">
            <div className="container">
              <div className="columns  is-centered">
                <div className="column is-4 has-text-centered">
                  <ContentLoader type="facebook" />
                </div>
              </div>
            </div>
          </div>
        </section>
      );
    }

    // redirect if user is logged in
    if (
      this.props.loggedInUserQuery.loggedInUser &&
      this.props.loggedInUserQuery.loggedInUser.id
    ) {
      console.warn("already logged in");
      if (this.props.loggedInUserQuery.loggedInUser.role === "ADMIN") {
        this.props.history.replace("/admin");
      } else {
        this.props.history.replace("/");
      }
    }

    return (
      <ErrorBoundary>
        <section className="hero is-fullheight radial-background">
          <div className="hero-body">
            <div className="container has-text-centered">
              <h1 className="is-size-3">Bienvenue!</h1>
              <br />
              <div className="columns  is-centered">
                <div className="column is-4">
                  <div className="card">
                    <header className="card-header">
                      <h1 className="card-header-title has-text-centered is-size-3">
                        Se connecter
                      </h1>
                    </header>
                    <div className="card-content  has-text-left">
                      <form onSubmit={this.handleSubmit}>
                        <div className="field">
                          <label className="label">Email</label>
                          <div className="control">
                            <input
                              className={`input ${this.state.error
                                ? "is-danger"
                                : ""}`}
                              type="email"
                              onChange={e =>
                                this.setState({ email: e.target.value })}
                            />
                          </div>
                        </div>
                        <div className="field">
                          <label className="label">Mot de passe</label>
                          <div className="control">
                            <input
                              className={`input  ${this.state.error
                                ? "is-danger"
                                : ""}`}
                              type="password"
                              onChange={e =>
                                this.setState({ password: e.target.value })}
                            />
                          </div>
                        </div>
                        <div className="field  has-text-centered">
                          <Button
                            text="Se connecter"
                            type="submit"
                            disabled={this.state.disabled}
                          />
                        </div>
                      </form>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </ErrorBoundary>
    );
  }
}

const AUTHENTICATE_USER_MUTATION = gql`
  mutation AuthenticateUserMutation($email: String!, $password: String!) {
    authenticateUser(email: $email, password: $password) {
      token
    }
  }
`;

const LOGGED_IN_USER_QUERY = gql`
  query LoggedInUserQuery {
    loggedInUser {
      id
      role
    }
  }
`;
export default compose(
  graphql(AUTHENTICATE_USER_MUTATION, { name: "authenticateUserMutation" }),
  graphql(LOGGED_IN_USER_QUERY, {
    name: "loggedInUserQuery",
    options: { fetchPolicy: "network-only" }
  })
)(withRouter(LoginUser));



// WEBPACK FOOTER //
// ./src/components/LoginUser.js